import {Checkbox} from "@/components/ui/checkbox.tsx";
import {XMarkIcon} from "@heroicons/react/16/solid";
import React, {useState} from "react";
import ShareLink from '@/assets/search/share_link.svg?react'
import ShareImg from '@/assets/search/share_img.svg?react'
import {aiApi} from "@/api/aiApi.ts";
import {toast} from "sonner";
import ShareImgDialog from "@/pages/DetailPage/component/shareImgDialog.tsx";
import {useTranslation} from "@/locales";

interface ShareButtonProps {
    onChange: () => void;
    handleClose: () => void;
    isShare: boolean;
    checkList: string[];
    topicNo?: string;
}

interface GetShareResponse {
    url: string;
}

export const ShareButton = ({onChange, handleClose, isShare,checkList,topicNo}: ShareButtonProps) => {
    const {t} = useTranslation();
    const [isShareImg, setIsShareImg] = useState(false)

    const onShareLink = () =>{
        if(checkList.length && topicNo){
            aiApi.conversation.getShare({
                topicNo,
                conversationNos: checkList.join(',')
            }).then((res)=>{
                const share = res as GetShareResponse
                if(share){
                    // 复制到剪贴板
                    if (navigator.clipboard && navigator.clipboard.writeText) {
                        navigator.clipboard.writeText(share.url).then(() => {
                            toast.success(t('chat.copyLink') + t('common.success'), {
                                className: "bg-green-100",
                                duration: 2000,
                                icon: <SuccessIcon />
                            });
                        }).catch(() => {
                            toast.error(t('common.failed') + '，请手动复制链接');
                        });
                    } else {
                        // 兼容旧浏览器的复制方案
                        const textArea = document.createElement('textarea');
                        textArea.value = share.url;
                        document.body.appendChild(textArea);
                        textArea.select();
                        try {
                            document.execCommand('copy');
                            toast.success(t('chat.copyLink') + t('common.success'), {
                                className: "bg-green-100",
                                duration: 2000,
                                icon: <SuccessIcon />
                            });
                        } catch {
                            toast.error(t('common.failed') + '，请手动复制链接');
                        }
                        document.body.removeChild(textArea);
                    }
                }

            })
        }
    }

    const onShareImg = () =>{
        setIsShareImg(true)
    }

    const SuccessIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
    );

    return <div className={'flex flex-col items-center h-[128px] '}>
        <div className={'text-[12px] text-[var(--yb_text_tertiary)] mb-[12px] text-center w-full'}>{t('chat.tip')}</div>
        <div className={'flex items-center justify-between max-w-[1017px] w-full'}>
            <div className={'border-r border-solid border-[#EBEBEB]'} onClick={onChange}>
                <Checkbox checked={isShare} onCheckedChange={onChange} />
               <span className={'ml-[8px] mr-[25px]'}> {t('chat.selectAll')} </span>
            </div>
            <div className={'flex justify-center gap-[90px] flex-1'}>
                <div className={'share_item'} onClick={onShareLink}>
                    <div className={'share_button_item'}>
                        <ShareLink />
                    </div>
                    {t('chat.copyLink')}
                </div>
                <div className={'share_item'}>
                    <div className={'share_button_item'} onClick={onShareImg}>
                        <ShareImg />
                    </div>
                    {t('chat.generateImage')}
                </div>

            </div>
            <div className={''}>
                <button
                    className='text-token-text-secondary hover:bg-[#e8e8e8] rounded-lg h-[32px] w-[32px] mr-1 flex items-center justify-center'
                    onClick={handleClose}>
                    <XMarkIcon className='w-[22px] h-[22px]'></XMarkIcon>
                </button>
            </div>
            <ShareImgDialog isOpen={isShareImg}
                            onClose={() => {
                                setIsShareImg(false)
                                handleClose()
                            }}
                            shareIds={checkList}
                            topicNo={topicNo}/>
        </div>
    </div>;

}
